// extracted by mini-css-extract-plugin
module.exports = {"box":"RelativeValues_box__1y5xZ","content":"RelativeValues_content__3yFPc"};